<template>
  <div
    class="font-normal whitespace-pre-wrap text_color"
    v-html="formattedContent"
  ></div>
</template>

<script setup>
import { computed } from "vue";
import { convertURLsToLinks } from "@/src/utils/utils.js";

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const formattedContent = computed(() => convertURLsToLinks(props.content));
</script>

<style>
.tagged_email {
  background-color: var(--white-opacity-12);
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}
</style>
